// Module
var code = `<div class="terceraEventLog" style="display:{{.visible?'':'none'}}" on-click='test'>
    <terceraButton  name="event_log"
        SVG="true"
        checked="{{.isEventLogOpened}}"
        terceraButtonStyle="js-button-eventlog" 
        on-componentClick="eventLogClick"
        tooltip="{{.tooltip}}"/>
</div>`;
// Exports
export default code;